module.exports = __webpack_public_path__ + "797baaaed4445f34a72ee39e94a8c849.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/tape-1.svg
// module id = 483
// module chunks = 0